import styled from 'styled-components'
import { colors } from '../../../Global/Styles/variables'

interface SectionProps {
  maxWidth: string
  flexWrap: boolean
}

interface TableProps {
  borderBottomColor?: string
  thBgColor?: string
  thTextColor?: string
  tdBorderBottomColor?: string
}

export const Header = styled.header`
  display: flex;
  width: 100%;
`

export const Section = styled.section<SectionProps>`
  width: 100%;
  display: flex;
  max-width: ${({ maxWidth }) => maxWidth};
  margin: 0px auto;
  ${({ flexWrap }) => flexWrap && 'flex-wrap: wrap;'}
`

export const Main = styled.main`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  justify-content: center;
  flex-direction: column;
  align-content: center;
`

export const FooterContainer = styled.footer`
  display: flex;
  flex-basis: 100%;
  flex-wrap: wrap;
  justify-content: center;
`

export const Error = styled.p`
  width: 100%;
  padding: 1rem 0;
  color: red;
`

export const Success = styled.p`
  width: 100%;
  padding: 1rem 0;
  color: green;
`

export const Table = styled.table<TableProps>`
  table-layout: fixed;
  width: 100%;
  border-collapse: collapse;

  thead {
    position: sticky;
    top: 0;
    z-index: 1;
  }

  th {
    padding: 0.5rem 0;
    font-size: 1rem;

    div {
      display: flex;
      align-items: center;
    }

    img {
      margin-left: 0.5rem;
      width: 0.5rem;
      height: 1.25rem;
    }
  }

  th:first-child {
    padding-left: 0.75rem;
    border-top-left-radius: 0.375rem;
  }

  th:last-child {
    border-top-right-radius: 0.375rem;
  }

  td {
    padding: 1rem 0.2rem 1rem 0;
  }

  td:first-child {
    padding-left: 0.75rem;
  }

  th,
  td {
    text-align: left;
  }

  ${({ borderBottomColor, thBgColor, thTextColor, tdBorderBottomColor }) => `
    border-bottom: 0.125rem solid ${borderBottomColor || colors.darkBlue};

    th {
      background-color: ${thBgColor || colors.darkBlue};
      color: ${thTextColor || colors.white};
    }
    
    td {
      ${
        tdBorderBottomColor && `border-bottom: 1px solid ${tdBorderBottomColor}`
      };
    }
  `}
`
